import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { Permission } from "../core/enums/permission.enum";
import { routeSettings } from "../core/routes.config";
import { authGuard } from "../shared/guards/auth.guard";
import { DashboardComponent } from "./dashboard.component";

const routes: Routes = [
  {
    path: "",
    component: DashboardComponent,
    children: [
      {
        path: routeSettings.dispatch.path,
        loadChildren: () => import("./feature/dispatch/dispatch.module").then(m => m.DispatchModule),
        canActivate: [authGuard],
        data: {
          permissions: [
            Permission.Administrator, 
            Permission.UnionDispatcher, 
            Permission.UnionSupervisor
          ]
        }
      },
      {
        path: routeSettings.orders.path,
        loadChildren: () => import("./feature/orders/orders.module").then((m) => m.OrdersModule),
        canActivate: [authGuard],
        data: {
          permissions: [
            Permission.Administrator,
            Permission.UnionDispatcher,
            Permission.EmployerTest,
            Permission.UnionSupervisor
          ]
        }
      },
      {
        path: routeSettings.availability.path,
        loadChildren: () => import("./feature/availability/availability.module").then((m) => m.AvailabilityModule),
        canActivate: [authGuard],
        data: {
          permissions: [
            Permission.Administrator,
            Permission.UnionDispatcher,
            Permission.UnionSupervisor
          ]
        }
      },
      {
        path: routeSettings.dispatchByDate.path,
        loadChildren: () => import("./feature/dispatch-by-date/dispatch-by-date.module").then((m) => m.DispatchByDateModule),
        canActivate: [authGuard],
        data: {
          permissions: [
            Permission.Administrator,
            Permission.UnionDispatcher,
            Permission.UnionSupervisor
          ]
        }
      },
      {
        path: routeSettings.podium.path,
        loadChildren: () => import("./feature/podium/podium.module").then((m) => m.PodiumModule),
        canActivate: [authGuard],
        data: {
          permissions: [
            Permission.Administrator,
            Permission.UnionDispatcher
          ]
        }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
